
function promoBannerHeightCalculation() {
	let banner = document.querySelector('.promo-banner');
	if (!banner) return;
	const main = document.querySelector('main.content');
	if (!main) return;
	const header = document.querySelector('.header');

	let bannerHeight = banner.offsetHeight
	let headerHeight = header.offsetHeight;
	main.style.marginTop = '-' + (bannerHeight + headerHeight) + 'px';

	let bannerHeightResizeTimer;
	let vw = window.innerWidth;

	window.addEventListener('resize', (e) => {
		clearTimeout(bannerHeightResizeTimer);
		let new_vw = window.innerWidth;

		if (new_vw !== vw) {
			bannerHeightResizeTimer = setTimeout(() => {
				const bannerHeight = banner.offsetHeight
				const headerHeight = header.offsetHeight;
				main.style.marginTop = '-' + (bannerHeight + headerHeight) + 'px';
				vw = window.innerWidth;
			}, 500);
		}
	});
}

promoBannerHeightCalculation();